import { Constants } from './quickshop-constants';
import QuickShopClass from './product-quickshop';

const QuickShopButtons = () => {
  $(document.body).on('click', Constants.els.quickShopTrigger, function (e) {
    e.preventDefault();
    const isSample = $(this).data('is-sample');
    if (isSample && $(this).hasClass('cta-button--disabled')) {
      e.stopPropagation();
      return;
    }
    const productHandle = $(this).data('quickshop-view');
    const productCard = $(this).closest('.prod-card');
    const sampleKit = productCard.data('sample-kit');
    const sampleKitWeight = productCard.data('sample-kit-weight');
    const sampleHandle = productCard.data('sample-handle');
    const sampleVariantId = productCard.data('sample-variant-id');

    QuickShopClass.getInstance().addToQuickshop(productHandle, isSample, {
      sampleKit,
      sampleKitWeight,
      sampleHandle,
      sampleVariantId,
    });
  });

  $(document.body).on('click', Constants.els.quickShopUnderlay, function (e) {
    e.preventDefault();
    e.stopPropagation();
    QuickShopClass.getInstance().toggleQuickShopOpen();
  });
};

export { QuickShopButtons };
